/*******************************************************************************

// Project: Diplom Shop 24
// Author: Prima-Line.de
// Date: 12.2017

********************************************************************************

  1. Polyfill for external SVG
  2. Scroll to top
  3. Off canvas menu
  4. Mobile Menu
  5. EU Cookie
  6. Polyfill to remove click delays on browsers with touch UIs
  7. Dropdown Menu
  8. Lightbox for images
  9. Responsive Videos
  10. Scoll Animations Init
  11. Object Fit Images
  12. Framework Scripts
  13. Contact Form 7 Fix
  14. Typewriter effect
  15. Image Slider
  16. Equal Heights
  17. Accordion
  18. Opinions
  19. Diplom Page
  20. Countdown

*******************************************************************************/

jQuery( document ).ready(function($) {

/* 1. Polyfill for external SVG
------------------------------------------------------------------------------*/

  svg4everybody();

/* 2. Scroll to top
------------------------------------------------------------------------------*/

  $(document).on( 'scroll', function(){
    if ($(window).scrollTop() > 200) {
      $('.scroll-to-top').addClass('show');
    } else {
      $('.scroll-to-top').removeClass('show');
    }
  });

  $('.scroll-to-top').on('click', function(event) {
    event.preventDefault();
    var verticalOffset = typeof(verticalOffset) != 'undefined' ? verticalOffset : 0;
    var element = $('body');
    var offset = element.offset();
    var offsetTop = offset.top;
    $('html, body').animate({scrollTop: offsetTop}, 500, 'linear');
  });

/* 3. Off canvas menu
------------------------------------------------------------------------------*/

  $('.toggle-nav').click(function() {
    // Calling a function in case you want to expand upon this.
    toggleNav();
  });

  function toggleNav() {
    if ($('#site-wrapper').hasClass('show-nav')) {
      // Do things on Nav Close
      $('#site-wrapper').removeClass('show-nav');
    } else {
      // Do things on Nav Open
      $('#site-wrapper').addClass('show-nav');
    }
  }

  // Fuction for hiding mobile navigation
  function hideNav() {
    if ($('#site-wrapper').hasClass('show-nav')) {
      $('#site-wrapper').removeClass('show-nav');
    }
  }

  // Hide navigation when user pressed Escape key on keyboard
  $(document).keyup(function(e) {
    if (e.keyCode === 27) {
      if ($('#site-wrapper').hasClass('show-nav')) {
        toggleNav();
      }
    }
  });

  // Hide mobile navigation when user increases browser size
  enquire.register("screen and (min-width: 768px)", {
    match : function() {
      hideNav();
    }
  });

/* 4. Mobile Menu
------------------------------------------------------------------------------*/

  $('ul.mob-menu li').has('ul').addClass('parentLi');
  $('ul.mob-menu li ul').addClass('sub-menu');

  $('ul.mob-menu .sub-menu').hide();

  $('ul.mob-menu .parentLi > a').on('click', function(event){
    event.preventDefault();
    $(this).toggleClass('expanded');
    $(this).parent().find('ul.sub-menu').slideToggle();
  });

/* 5. EU Cookie
------------------------------------------------------------------------------*/

  if(Cookies.get('eu-cookie-law-diplomshop') == 'accepted') {
    $('.cookie-bar').removeClass('cookie-bar--not-accepted');
  }
  else {
    $('.cookie-bar').addClass('cookie-bar--not-accepted');
    $('body').addClass('cookie-visible');
  }

  $('.js-accept-cookie').on('click', function(e){
    e.preventDefault();
    Cookies.set('eu-cookie-law-diplomshop', 'accepted', { expires: 180 });
    $('.cookie-bar').removeClass('cookie-bar--not-accepted');
    $('body').removeClass('cookie-visible');
  });

/* 6. Polyfill to remove click delays on browsers with touch UIs
------------------------------------------------------------------------------*/

  FastClick.attach(document.body);

/* 7. Dropdown Menu
------------------------------------------------------------------------------*/

  $('.primary-menu .menu-item-has-children > a, .top-menu .menu-item-has-children > a').on('click', function(e){
    e.preventDefault();
    $(this).parent().toggleClass('opened');
  });

  // Hide dropdown after click outside the menu
  $(document).on('click', function(event) {
    if (!$(event.target).closest('.primary-menu .menu-item-has-children a').length) {
      $('.primary-menu .menu-item-has-children').removeClass('opened');
    }
  });

/* 8. Lightbox for images
------------------------------------------------------------------------------*/

  $('a[href$=jpg], a[href$=jpeg], a[href$=jpe], a[href$=png], a[href$=gif]').magnificPopup({
    type: 'image',
    removalDelay: 500, //delay removal by X to allow out-animation
    callbacks: {
      beforeOpen: function() {
        // just a hack that adds mfp-anim class to markup
         this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
         this.st.mainClass = 'mfp-zoom-out';
      }
    },
    closeOnContentClick: true,
    midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
  });

/* 9. Responsive Videos
/*******************************************************************************/

  fitvids({
    // players: 'iframe[src*="example.com"]'
  });

/* 10. Scoll Animations Init
/*******************************************************************************/

  AOS.init({
    disable: 'mobile'
  });

/* 11. Object Fit Images
/*******************************************************************************/

  objectFitImages();

/* 12. Framework Scripts
/*******************************************************************************/

//= include framework-scripts.js

/* 13. Contact Form 7 Fix
/*******************************************************************************/

  $('.wpcf7-form p:empty').remove();

/* 14. Typewriter effect
/*******************************************************************************/

  var typedEl = document.getElementById('typed');
  if(typedEl) {
    var typed = new Typed('#typed', {
      stringsElement: '#typed-strings',
      typeSpeed: 150,
      startDelay: 2000,
      loop: true
    });
  }

/* 15. Image Slider
/*******************************************************************************/

  $('.img-slider--with-bottom-shadow').slick({
    arrows: false,
    dots: true,
    autoplay: true,
    fade: true,
    autoplaySpeed: 7000,
    speed: 1000,
    pauseOnHover: false
  });

  $('.img-slider--with-arrows').slick({
    arrows: true,
    dots: true,
    autoplay: true,
    fade: true,
    autoplaySpeed: 7000,
    speed: 1000,
    pauseOnHover: false
  });

/* 16. Equal Heights
/*******************************************************************************/

  $('.tiny-pricing-table__label, .tiny-pricing-table__price').matchHeight();
  $('.tiny-pricing-table__title-1, .tiny-pricing-table__title-2').matchHeight();
  $('.file-list__link').matchHeight();
  $('.teaser__content').matchHeight();

/* 17. Accordion
/*******************************************************************************/

  // Hide all accordions
  var allPanels = $('.accordion dd').hide();
  var allTitles = $('.accordion dt');

  // Show first accordion on page
  $('.accordion__text').first().addClass('accordion__text--active').slideDown();
  $('.accordion__subtitle').first().addClass('accordion__subtitle--active');

  $('.accordion dt > a').click(function(e) {
    e.preventDefault();
    $this = $(this);
    $title = $this.parent();
    $target =  $this.parent().next();

    if(!$target.hasClass('accordion__text--active')){
      allPanels.removeClass('accordion__text--active').slideUp();
      allTitles.removeClass('accordion__subtitle--active');
      $target.addClass('accordion__text--active').slideDown();
      $title.addClass('accordion__subtitle--active');
    }
    else {
      allPanels.removeClass('accordion__text--active').slideUp();
      allTitles.removeClass('accordion__subtitle--active');
    }
    return false;
  });

/* 18. Opinions
/*******************************************************************************/

  $('.wrap-box').slick({
    arrows: false,
    dots: true
  });

/* 19. Diplom Page
/*******************************************************************************/

  $('.diplom__colors-slider').slick({
    arrows: false,
    dots: true,
    slidesToShow: 1,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: true,
          dots: false
        }
      }
    ]
  });

/* 20. Countdown
/*******************************************************************************/

  var timeLimit = $('#time-limit').text();

  $('#clock').countdown(timeLimit)
    .on('update.countdown', function(event) {
      var format = '<span class="text--highlighted">%-H</span> h <span class="text--highlighted">%-M</span> Min.';
      if(event.offset.totalDays > 0) {
        format = '<span class="text--highlighted">%-d</span> Tag%!d ' + format;
      }
      if(event.offset.weeks > 0) {
        format = '<span class="text--highlighted">%-w</span> Woche%!w ' + format;
      }
      $(this).html(event.strftime(format));
    })
    .on('finish.countdown', function(event) {
      $(this).html('Countdown abgelaufen - Seite neu laden!');
    });

});
